import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-menu\">\n    <path fill-rule=\"nonzero\" d=\"M1 2h10a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2zm0 5h14a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2zm0 5h8a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol